import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookPages = () =>
  useQuery<crmModels.IFacebookPage[]>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_PAGES],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/facebook/pages');

      return res?.data?.data;
    }
  });
